const initialState = {
  newReportForm: false,
};

export default initialState;
